// eslint-disable-next-line import/no-cycle
import feathersClient from "../../feathers-client";

const defaultRateEscalationChecklistPagination = {
	total:100,
	$skip:0,
	$limit:10,
};
const defaultRateEscalationChecklistPaginationFilter = {
	$skip:defaultRateEscalationChecklistPagination.$skip,
	$limit: defaultRateEscalationChecklistPagination.$limit
};

export default {
	state:{
		RateEscalationChecklist:[],
		RateEscalationChecklistPagination:defaultRateEscalationChecklistPagination,
		RateEscalationChecklistPaginationFilter:defaultRateEscalationChecklistPaginationFilter
	},
	getters:{
		setRateEscalationChecklistPage:(state) => {
			const {$limit, $skip} = state.RateEscalationChecklistPagination;
			return $skip / $limit + 1;
		}

	},
	mutations:{
		SET_RATE_ESCALATION_CHECKLIST:(state,data) => {state.RateEscalationChecklist = data;},
		SET_RATE_ESCALATION_CHECKLIST_PAGINATION:(state, data) => {state.RateEscalationChecklistPagination = {...state.RateEscalationChecklistPagination, ...data};},
		SET_RATE_ESCALATION_CHECKLIST_PAGINATION_FILTER:(state,data) => {state.RateEscalationChecklistPaginationFilter  = {...state.RateEscalationChecklistPaginationFilter, ...data};}

	},
	actions:{
		setRateEscalationChecklistListPage:({commit,state},page) =>{
			const $skip = (page - 1) * state.RateEscalationChecklistPagination.$limit;
			commit('SET_RATE_ESCALATION_CHECKLIST_PAGINATION', { $skip });
			commit('SET_RATE_ESCALATION_CHECKLIST_PAGINATION_FILTER', { $skip });
		},

		getRateEscalationChecklist: async({rootGetters,commit},filter) => {
			const results = await feathersClient.service('/api/v3/rate-escalation-checklist-items').find({
				query:{
					$role: rootGetters.currentUserRole,
					...filter
				}
			});
			commit('SET_RATE_ESCALATION_CHECKLIST',results.data);
			commit('SET_RATE_ESCALATION_CHECKLIST_PAGINATION', {total :results.total})
			return results.data;
		},
		createRateEscalationChecklist: async({rootGetters,commit},data) => {
			const results = await feathersClient.service('/api/v3/rate-escalation-checklist-items').create(data,{
				query:{
					$role: rootGetters.currentUserRole,
				}
			});
			return results;
		},
		updateRateEscalationChecklist: async({rootGetters,commit},data) => {
			const results = await feathersClient.service('/api/v3/rate-escalation-checklist-items').patch(data.id, data,{
				query:{
					$role: rootGetters.currentUserRole,
				}
			});
			return results;
		},
		deleteRateEscalationChecklist: async ({rootGetters},id) => {
			const results = await feathersClient.service('/api/v3/rate-escalation-checklist-items').remove(id,{
				query:{
					$role:rootGetters.currentUserRole,
				}
			});
			return results;
		},
		getRateEscalationChecklistById: async({rootGetters},id) =>{
			const results = await feathersClient.service('/api/v3/rate-escalation-checklist-items').get(id,{
				query:{
					// $role: rootGetters.currentUserRole,
				}
			});

			return results
		},
		getRateEscalationChecklistStatusById: async({rootGetters},id) =>{
			const results = await feathersClient.service('/api/v3/rate-escalation-checklist-status').get(id,{
				query:{
					// $role: rootGetters.currentUserRole,
				}
			});

			return results
		},
		getAllRateEscalationChecklistForTrust: async({rootGetters}) => {
			const results = await feathersClient.service('/api/v3/rate-escalation-checklist-items').find({
				query:{
					$role:rootGetters.currentUserRole,

				}
			});
			return results;
		},
		getAllRateEscalationChecklist: async({rootGetters}) => {
			const results = await feathersClient.service('/api/v3/rate-escalation-checklist-items').find({
				query:{
					$role:rootGetters.currentUserRole,
				}
			});
			return results.data;
		},

		createRateEscalation: async({rootGetters,commit},data) => {
			const results = await feathersClient.service('/api/v3/rate-escalations').create(data,{
				query:{
					$role: rootGetters.currentUserRole,
				}
			});
			return results;
		},
		updateRateEscalation: async({rootGetters,commit},data) => {
			const results = await feathersClient.service('/api/v3/rate-escalations').patch(data.id, data,{
				query:{
					$role: rootGetters.currentUserRole,
				}
			});
			return results;

		},
		createCommentForRateEscalation: async({rootGetters,commit},data) => {
			const results = await feathersClient.service('/api/v3/comments').create(data,{
				query:{
					$role: rootGetters.currentUserRole,
				}
			});
			return results;
		},


	}
}
